import React from 'react';
// Attualmente per via degli export di questo file, se importassimo
// @storybook/addon-actions, si verificherebbe un errore di runtime
// perché non è una dipendenza di produzione.
// Non possiamo aggiungerla perché è una dipendenza di sviluppo.
// import { action } from '@storybook/addon-actions';
import { useTranslation } from '@framework/i18n';
import { yup } from '@framework/validation';
import { Button } from 'antd';
import { FormHandler, IFormHandlerProps } from '../form/FormHandler';

function StorybookFormDecoratorProvider(props: IFormHandlerProps<any>) {
  return <FormHandler {...props}>{props.children}</FormHandler>;
}

interface IFormDecoratorProps
  extends Omit<IFormHandlerProps<any>, 'schema' | 'onSubmit' | 'children'> {
  showSubmit?: boolean;
  schema?: IFormHandlerProps<any>['schema'];
  onSubmit?: IFormHandlerProps<any>['onSubmit'];
}

/**
 * Da utilizzare per decorare una storia di Storybook con un form.
 */
export function decorateWithForm(options: IFormDecoratorProps = {}) {
  const { showSubmit, ...props } = options;
  const handleSubmit = (data: any, event: React.SyntheticEvent<any>) => {};

  const schema = options.schema ?? yup.object({} as any);

  // eslint-disable-next-line react/display-name
  return (Story: any) => {
    const { t } = useTranslation();

    return (
      <StorybookFormDecoratorProvider
        {...props}
        schema={schema}
        onSubmit={
          options.onSubmit ??
          (data => {
            console.log('SUBMIT', data);
            // action('[React Hooks Form] Submit')(data);
          })
        }
      >
        <Story />
        {options.showSubmit && (
          <Button htmlType="submit">
            {t('utils.decorate-with-form.submit', 'Invia')}
          </Button>
        )}
      </StorybookFormDecoratorProvider>
    );
  };
}
